import * as React from "react";
import PropTypes from "prop-types";
import FormField from "./FormField";
import { Divider } from "../ItemList";

const style = { overflowX: "hidden" };

export default class Form extends React.Component {
  static propTypes = {
    fields: PropTypes.arrayOf(PropTypes.shape(FormField.propTypes)),
    onChange: PropTypes.func, // (name: string, value: any) => void
    onSubmit: PropTypes.func, // (event: Event) => void
    onBlur: PropTypes.func, // (event: Event) => void
    onEnterPressed: PropTypes.func, // () => void
    autoFocusField: PropTypes.string, // Field name or undefined
    shouldScrollIntoView: PropTypes.bool,
  };

  static defaultProps = {
    fields: [],
  };

  _handleChange(name, value) {
    if (!this.props.onChange) {
      return;
    }
    this.props.onChange(name, value);
  }

  _handleSubmit = (event) => {
    event.preventDefault(); // Don't refresh the page

    const { onSubmit } = this.props;
    if (onSubmit != null) {
      onSubmit(event);
    }
  };

  render() {
    const {
      fields,
      onBlur,
      onEnterPressed,
      autoFocusField,
      shouldScrollIntoView,
    } = this.props;

    // jsx-a11y has a bug which will be fixed in a later version
    // https://github.com/evcohen/eslint-plugin-jsx-a11y/issues/253
    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    return (
      <form style={style} onSubmit={this._handleSubmit} onBlur={onBlur}>
        {fields.map((field, index) => (
          <div key={field.name}>
            <FormField
              {...field}
              shouldScrollIntoView={shouldScrollIntoView}
              onChange={(value) => this._handleChange(field.name, value)}
              onEnterPressed={onEnterPressed}
              autoFocus={autoFocusField === field.name}
            />
            {fields[index + 1] && <Divider />}
          </div>
        ))}
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Form/index.jsx